<template>
	<div
		:style="{
			position: isGlobal ? 'fixed' : 'absolute',
		}"
		class="page-loading-wrap"
	>
		<div class="loading-bg"></div>
		<div class="el-loading-spinner">
			<img class="loader-icon" src="../../assets/images/loading.png" />
		</div>
	</div>
</template>
<script>
export default {
	props: {
		isGlobal: {
			type: Boolean,
			default: true,
		},
	},
}
</script>

<style lang="scss" scoped>
.page-loading-wrap {
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 10001;
	.loading-bg {
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.3);
	}
	.el-loading-spinner {
		top: 50%;
		margin-top: -21px;
		height: 24px;
		width: 100%;
		text-align: center;
		position: absolute;
	}
	.loader-icon {
		display: inline-block;
		width: 24px;
		height: 24px;
		position: relative;
		-webkit-animation: spin 2s linear infinite;
		animation: spin 2s linear infinite;
		color: #fff;
	}
}

@-webkit-keyframes spin {
	0% {
		-webkit-transform: rotate(0deg);
		-ms-transform: rotate(0deg);
		transform: rotate(0deg);
	}
	100% {
		-webkit-transform: rotate(360deg);
		-ms-transform: rotate(360deg);
		transform: rotate(360deg);
	}
}
@keyframes spin {
	0% {
		-webkit-transform: rotate(0deg);
		-ms-transform: rotate(0deg);
		transform: rotate(0deg);
	}
	100% {
		-webkit-transform: rotate(360deg);
		-ms-transform: rotate(360deg);
		transform: rotate(360deg);
	}
}
</style>
